module.exports = __webpack_public_path__ + "img/232-yemen.be5d2742.svg";